import { forwardRef } from 'react';
import MuiAlert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { closeSnackbar } from 'notistack';

const CustomSnackbar = forwardRef(({ id, message, variant }, ref) => (
  <MuiAlert
    ref={ref}
    variant="filled"
    severity={variant === 'error' ? 'error' : variant === 'success' ? 'success' : 'info'}
    action={
      <IconButton size="small" color="inherit" onClick={() => closeSnackbar(id)}>
        <CloseIcon fontSize="small" />
      </IconButton>
    }
    sx={{ width: '100%', alignItems: 'center' }}
  >
    {message}
  </MuiAlert>
));

export default CustomSnackbar;
